import api from 'api'
import { ICertificate, IMyCertificate } from 'models/certificate.model'
import { ICourseModel } from 'models/course.model'

interface ResCertificates {
  data: {
    id?: number
    attributes: {
      createdAt: string
      name: string
      certificate: {
        data: { attributes: ICertificate }
      }
      courseId: number
      course?: ICourseModel
    }
  }[]
}

const myCertificatesList = () => {
  return api
    .get<ResCertificates>('/certificates/')
    .then(({ data }): { data: IMyCertificate[] } => {
      return {
        data: data.data.map(
          ({ attributes: { certificate, ...rest } }): IMyCertificate => ({
            ...rest,
            certificate: certificate.data.attributes,
          })
        ),
      }
    })
}

export default myCertificatesList
